import React, { useState } from "react";

import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Chart from "react-apexcharts";
import { Card, CardBody } from "../../components/card/card.jsx";
import { ModalComponent } from "../expand/expandmodal.jsx";
import { getChartOptions } from "../../helpers/chartOptions";
import { dateOptions, AgeOptionsNew } from "../../components/selectvalues/selectvalue.jsx";
import { fetchUserTileInfo } from "../../actions/dashboard_actions.js";
import { Colors } from "chart.js";
import CardLoader from "../card/CardLoader.jsx";



// console.log('Colors:', Colors);

// Helper: Compute the mini chart data using stats_q1.
// We use previous week and last week.
const computeMiniChartData = (stats_q1) => {
  return [
    {
      name: "Users",
      data: [
        { x: "Previous Week", y: stats_q1 ? stats_q1.user_previous_week : 0 },
        { x: "Last Week", y: stats_q1 ? stats_q1.user_last_week : 0 },
      ],
    },
  ];
};

const TotalRegisteredUsersCard = ({
  stats_q1,                // Q1 summary data (object)
  loading_q1,              // Boolean for loading collapsed view
  user_tile_info,          // Detailed data array for expanded view (from API, key "dateswise")
  loading_user_tile_info,  // Boolean for detailed view loading state
  passedDispatch,
  themeCol,
  chartOptions
  
}) => {
  // --- Expand Modal - Local search control state
  const [selectedDateOption, setSelectedDateOption] = useState(dateOptions[3]); // default to non-custom, e.g., "default"
  const [customDateRange, setCustomDateRange] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedAgeOption, setSelectedAgeOption] = useState(AgeOptionsNew[0]);
  // console.log('Theme Color is:', themeCol)
    // console.log('user_tile_info from Total Registered Users:', user_tile_info);
  // Handlers for search controls.
  const handleDateOptionChange = (option) => {
    setSelectedDateOption(option);
    setCustomDateRange(option.value === 3);
    console.log('Custom Date Range:', customDateRange)
  };

  

  const customTooltip = {
    // ...chartOptions,
    // colors: [themeCol],
    tooltip: {
    bar: {
        x: {
          show: true,
          formatter: (val, opts) => {
            const labels = ['Previous Week', 'Current Week'];
            return typeof opts.dataPointIndex !== 'undefined'
              ? labels[opts.dataPointIndex]
              : val;
          }
        },
        y: {
          formatter: (val) => `${val}`
        }
    }
  }
  };

  // Get the theme-based chart options.
  // const chartOptions = getChartOptions(customTooltip);

  const handleChangeStart = (date) => { setStartDate(date)} ;
  const handleChangeEnd = (date) => setEndDate(date);
  const handleAgeOptionChange = (option) => setSelectedAgeOption(option);


  // Trigger detailed search. Replace with your actual API-dispatch logic.
  const handleDetailedSearch = () => {

  const value = selectedAgeOption.value;
  const [firstAge, secondAge] = value.includes('-')
    ? value.split('-').map(Number)
    : '0-100'.split('-').map(Number);

  const currentYear = new Date().getFullYear();
  console.log(
    'Params changing in Reusable - Total Registered Users Card:',
    selectedDateOption.value,
    'users',
    startDate,
    endDate,
    firstAge,
    secondAge
  );

  // Helper function: convert date to ISO string without milliseconds
  const formatDate = (date) => date.toISOString().replace(/\.\d{3}Z$/, 'Z');

  // Default dates: January 1st of last year and December 31st of the current year.
  const defaultStart = formatDate(new Date(currentYear - 1, 0, 1, 0, 0, 0));
  const defaultEnd = formatDate(new Date(currentYear, 11, 31, 23, 59, 59));
  passedDispatch(
    fetchUserTileInfo(
      selectedDateOption.value,
      "barsysdb.users",
      selectedDateOption.value === 3 ? formatDate(startDate) : defaultStart,
      selectedDateOption.value === 3 ? formatDate(endDate) : defaultEnd,
      firstAge,
      secondAge
    )
  );
    // In this example, we assume that user_tile_info gets updated externally.
  };

  // Build the expanded modal content.
  const TotalUserExpand = (
    <>
      <h3>TOTAL REGISTERED USERS</h3>
      <div className="row">
        {stats_q1 && (
          <h2 className="col-xl-3">{stats_q1.total_users.toLocaleString('en-US')}</h2>
        )}
        <div className="col-md-2">
          <label>Date Dimension</label>
          <Select
            options={dateOptions}
            value={selectedDateOption}
            onChange={handleDateOptionChange}
            classNamePrefix="react-select"
          />
              {customDateRange && (
                
                <div className="row col-xl-14">
                  
                  <div className="col-md-6">
                    <br />
                    <label>Date From:</label>
                    <DatePicker
                      selected={startDate}
                      onChange={handleChangeStart}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <br />
                    <label>Date To:</label>
                    <DatePicker
                      selected={endDate}
                      onChange={handleChangeEnd}
                      className="form-control"
                    />
                  </div>
                </div>
              )}
        </div>
        <div className="col-md-2">
          <label>Age</label>
          <Select
            options={AgeOptionsNew}
            value={selectedAgeOption}
            onChange={handleAgeOptionChange}
            classNamePrefix="react-select"
          />
        </div>
        <div className="col-md-2">
          <label>Location</label>
          <select className="form-control">
            <option value="all">All</option>
          </select>
        </div>
        <div className="col-md-2 mt-3 pt-1">
          <button className="btn btn-secondary" onClick={handleDetailedSearch}>
            <i className="fas fa-search"></i>
          </button>
        </div>
      </div>
      <div className="col-lg-12 mb-1 mb-lg-0">
        {loading_user_tile_info ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
            <div
              className="spinner-border"
              role="status"
              style={{ color: 'var(--bs-theme)' }} // uses your theme color instead of blue
            >
              <span className="visually-hidden">Loading detailed data...</span>
            </div>
          </div>
        ) : user_tile_info && user_tile_info.length > 0 ? (
          <Chart
            type="bar"
            options={{
              chart: { type: "bar" },
              colors: [themeCol],       // this is fine as your global palette
              plotOptions: {
                bar: {
                  dataLabels: {
                    position: "top",
                  },
                },
              },
              dataLabels: {
                enabled: true,            // be explicit
                offsetY: -20,
                style: {
                  fontFamily: "Chakra Petch",
                  fontSize: "10px",
                  fontWeight: "600",
                  colors: [themeCol],     // ← wrap it in an array
                },
              },
              xaxis: {
                categories: user_tile_info.map(item => item.label),
                labels: {
                  // rotate: 45,        
                  style: {
                    fontFamily: "Chakra Petch",
                    fontSize: "12px",
                    colors: [themeCol],   // ← wrap this one too
                  },
                },
              },
              yaxis: {
                labels: {
                  style: {
                    fontFamily: "Chakra Petch",
                    fontSize: "12px",
                    colors: [themeCol],
                  },
                },
              },
            }}

            series={[
              { name: "Users", data: user_tile_info.map(item => item.value) }
            ]}
            height="600"
          />
        ) : (
          <div className="text-center">No detailed data available</div>
        )}
      </div>
      {/* {stats_q1 && (
        <h5>
          {stats_q1.user_previous_week > 0 ? (
            stats_q1.user_last_week !== stats_q1.user_previous_week ? (
              <>
                <i className={`fas ${stats_q1.user_last_week > stats_q1.user_previous_week ? "fa-angle-up" : "fa-angle-down"}`}></i>
                &nbsp;
                {Math.abs(
                  ((stats_q1.user_last_week - stats_q1.user_previous_week) / stats_q1.user_previous_week) * 100
                ).toFixed(2)}{" "}
                %{" "}
                {stats_q1.user_last_week > stats_q1.user_previous_week ? "more" : "less"} than last week
              </>
            ) : (
              "No change from last week"
            )
          ) : (
            "Data Unavailable"
          )}
        </h5>
      )} */}
    </>
  );

  // Prepare a new stat object (for collapsed view) based on the Q1 stats
  const stat = stats_q1
    ? {
        title: "TOTAL REGISTERED USERS",
        total: stats_q1.total_users.toLocaleString('en-US'),
        chartType: "bar",
        chartHeight: 60,
        // Use the mini chart data computed from Q1
        chartData: computeMiniChartData(stats_q1),
        info: [
          {
            icon: "fa fa-chart-line fa-fw",
            text: `${stats_q1.user_previous_week.toLocaleString('en-US')} - Previous Week`,
            tooltip: "Previous Week",
          },
          {
            icon: "fa fa-chart-bar fa-fw",
            text: `${stats_q1.user_last_week.toLocaleString('en-US')} - Current Week`,
            tooltip: "Current Week",
          },
          {
            icon: "fa fa-percent fa-fw",
            text: `Change: `,
            text2: `${stats_q1.last_week_percent_relative_to_previous.toFixed(2)}%`,
            value: stats_q1.last_week_percent_relative_to_previous.toFixed(2),
            tooltip: "Change",
          },
          {
            icon: "fa fa-percent fa-fw",
            text: `Current is ${stats_q1.last_week_percent_relative_to_total.toFixed(2)}% of Total`,
            tooltip: "Relative to Total",
          },
        ],
      }
    : null;

  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex fw-bold small mb-3 align-items-center">
          {stat && <span className="flex-grow-1">{stat.title}</span>}
          {/* ModalComponent triggers the expanded modal view */}
          <ModalComponent cardBodyContent={TotalUserExpand} />
        </div>
        <div className="row align-items-center mb-2">
          <div className="col-7">
            <h3 className="mb-0">
              {loading_q1 ? (
                <div
                  className="spinner-border"
                  role="status"
                  style={{ color: 'var(--bs-theme)' }} // Replace with your custom theme variable if needed
                >
                  <span className="visually-hidden">Loading stat...</span>
                </div>
              ) : stat ? (
                stat.total
              ) : (
                "Data Unavailable"
              )}
            </h3>
          </div>
          <div className="col-5">
            <div className="mt-n2 position-relative" style={{ minHeight: 60 }}>
              {loading_q1 && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ color: 'var(--bs-theme)' }}  // Uses your custom theme color
                  >
                    <span className="visually-hidden">Loading chart...</span>
                  </div>
                </div>
              )}
              {!loading_q1 && stat && stat.chartType === "bar" && (
                <Chart
                  type="bar"
                  height={stat.chartHeight}
                  options={chartOptions.bar}
                  series={stat.chartData}
                />
              )}
            </div>
          </div>
        </div>
        <div className="small text-inverse text-opacity-50 text-truncate">
          {stat &&
            stat.info &&
            stat.info.map((info, idx) => (
              <div key={idx} title={info.tooltip}>
                <i className={info.icon}></i> <span>{info.text}</span><span style={{ color: parseFloat(info.value) >= 0 ? 'green' : 'red' }}>{info.text2}</span>
              </div>
            ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default TotalRegisteredUsersCard;
